import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, "是否关联学生？", -1)
const _hoisted_2 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "sing-play-confirm-mask",
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
  }, [
    _createElementVNode("div", {
      class: "sing-play-confirm-modal",
      onClick: _cache[3] || (_cache[3] = (e) => e.stopPropagation())
    }, [
      _createElementVNode("div", {
        class: "close-tool-tip",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
      }),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "cancel",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "否"),
        _createElementVNode("div", {
          class: "ok",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
        }, "是")
      ])
    ])
  ]))
}